import {
  ActionDropDown, Badge, Dropdown,
} from '@doveit/bricks';
import React from 'react';
import { OfferDeedStatus } from '../../../domain/types';
import { Offer } from '../../../providers/api/dtos';
import { useComputedOfferDeedStatus } from '../../hooks/use-computed-offer-deed-status/useComputedOfferDeedStatus';
import ConfirmOfferDeedAction from '../confirm-offer-deed-action/ConfirmOfferDeedAction';
import { computedOfferDeedStatusLabels, updateOfferDeedStatusColors } from './constants';

export interface UpdateOfferDeedStatusProps {
  offer: Offer,
  showAsBadge?: boolean,
  onSuccess?: VoidFunction,
  emphasis?: 'low' | 'high',
  size?: 'XS' | 'S',
}

const UpdateOfferDeedStatus: React.FC<UpdateOfferDeedStatusProps> = ({
  offer,
  showAsBadge = false,
  onSuccess,
  emphasis = 'low',
  size = 'S',
}) => {
  const { data: deedStatus } = useComputedOfferDeedStatus(offer);

  const label = React.useMemo(() => {
    if (!deedStatus) return '';

    return computedOfferDeedStatusLabels[deedStatus.status];
  }, [deedStatus]);

  const color = React.useMemo(() => {
    if (!deedStatus) return 'critical';

    return updateOfferDeedStatusColors[deedStatus.status];
  }, [deedStatus]);

  if (!deedStatus) {
    return null;
  }

  return (
    (!deedStatus.canBeUpdated || showAsBadge)
      ? (
        <Badge
          label={label}
          color={color}
          emphasis={emphasis}
          size={size}
          aria-label="Stato del rogito"
        />
      )
      : (
        <ActionDropDown
          label={label}
          color={color}
          emphasis={emphasis}
          size={size}
          aria-label="Modifica lo stato del rogito"
        >
          {deedStatus.canBeUpdatedTo(OfferDeedStatus.CONFIRMED) && (
            <ConfirmOfferDeedAction
              offer={offer}
              onSuccess={onSuccess}
            >
              {({ confirm, isSaving }) => (
                <Dropdown.Option
                  label="Conferma rogito"
                  onClick={confirm}
                  aria-label="Conferma il rogito"
                  loading={isSaving}
                />
              )}
            </ConfirmOfferDeedAction>
          )}
        </ActionDropDown>
      )
  );
};

export default UpdateOfferDeedStatus;
